import { render, staticRenderFns } from "./pagination-table.vue?vue&type=template&id=7024e3b7&"
import script from "./pagination-table.vue?vue&type=script&lang=ts&"
export * from "./pagination-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports